var checkScrollToBottom = function (event, mistake) {
    if (mistake === void 0) { mistake = 20; }
    var element = (event.target || event);
    var scrollHeight = element.scrollHeight, clientHeight = element.clientHeight, scrollTop = element.scrollTop;
    return scrollHeight - clientHeight - mistake <= scrollTop;
};

export { checkScrollToBottom };
